import i18n from '@/utils/i18n'
import PageAll from '@/components/PageAll'

const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/template',
        name: 'template',
		subheader: languages.template.title,
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            permCode: "11",
            icon: "file-markdown",
        },
        component: PageAll,
		children: [
			{
				path: '/voice',
				name: 'voice-template',
				component: resolve => require(['@/pages/template/voice/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.template.title1,
					permCode: "1101",
				},
			}
			// ,{
			// 	path: '/printer',
			// 	name: 'printer-template',
			// 	component: resolve => require(['@/pages/template/printer/index'], resolve),
			// 	meta: {
			// 		requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			// 		title: languages.template.title2,
			// 		permCode: "1102",
			// 	},
			// }
		]
    },
]
  